module.exports = __webpack_public_path__ + "img/aisidun.a0626bdf.png";